import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, mediaUrl } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export const fmtDate = (d) => {
  if (!d) return "";
  if (/^\d{4}$/.test(d)) return d;
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return d;
  }
};

export default function News() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/news").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-28 pb-24" data-testid="news-page">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="eyebrow mb-3">Dispatches</p>
          <h1 className="font-serif text-4xl sm:text-6xl text-slate-50">
            Latest From <span className="text-gold-gradient">The Horizon</span>
          </h1>
        </Reveal>
        <div className="mt-16 space-y-10">
          {posts.map((n, i) => (
            <Reveal key={n.id} delay={0.05}>
              <Link
                to={`/news/${n.id}`}
                data-testid={`news-list-item-${n.id}`}
                className="group grid grid-cols-1 sm:grid-cols-5 gap-6 rounded-2xl overflow-hidden border border-white/5 bg-navy-900/60 hover:border-gold-400/40 transition-colors duration-500"
              >
                <div className="sm:col-span-2 overflow-hidden flex items-center">
                  <img
                    src={mediaUrl(n.cover_url)}
                    alt={n.title}
                    className="w-full h-auto transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="sm:col-span-3 p-6 sm:py-8 flex flex-col justify-center items-center text-center">
                  <p className="text-[11px] tracking-[0.25em] uppercase text-gold-400/80">{fmtDate(n.date)}</p>
                  <h2 className="font-serif text-lg text-slate-100 mt-2 group-hover:text-gold-200 transition-colors sm:whitespace-nowrap">
                    {n.title}
                  </h2>
                  <p className="text-sm text-slate-400 mt-3 font-light line-clamp-3">{n.body.split("\n")[0]}</p>
                  <span className="mt-4 text-[11px] tracking-[0.2em] uppercase text-gold-300/80">Read the story</span>
                </div>
              </Link>
            </Reveal>
          ))}
          {posts.length === 0 && <p className="text-slate-500">No stories yet — check back soon.</p>}
        </div>
      </div>
    </div>
  );
}
